import React from 'react';

import { Box, Typography } from '@mui/material';

import { tcc } from './palette';

export default function SectionHeading({
  title,
  subtitle,
  accent = tcc.booked,
}: {
  title: string;
  subtitle: string;
  accent?: string;
}) {
  return (
    <Box data-level-heading sx={{ borderLeft: `5px solid ${accent}`, pl: 1.5, my: 2 }}>
      <Typography component="h2" sx={{ fontSize: { xs: 24, md: 28 }, fontWeight: 700, lineHeight: 1.25 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {subtitle}
      </Typography>
    </Box>
  );
}
